module.exports = __webpack_public_path__ + "img/404.2b5a5c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/404.png
// module id = zAji
// module chunks = 85